import {trim} from "es-toolkit";

// Similar to `BlokLink`
export type LinkShape = {
	cached_url: string;
	anchor?: string;
	linktype: string;
	url?: string;
	story?: {
		url: string;
	};
};

export default function formatSbUrl(link: LinkShape | undefined | null) {
	// Try to return a valid URL if none is given
	if (!link) {
		return "#";
	}

	// There's two main types of links in SB, external links and internal links to a story (plus email and asset links). External links (and other types) have the "url" field, story links however have a "story" object, IF the `resolve_links` param is used when fetching the story. "cached_url" is present always and we fall back to it if there's nothing else BUT it is only set by SB when the initial non-empty value for the field is set, it never gets updated automatically after that even if the story the link points to gets moved to a new path, so it's borderline useless.
	const url = link.url || link.story?.url || link.cached_url;

	// Try to return a valid URL if none is given
	if (!url || url.length === 0) {
		return "#";
	}

	if (link.linktype === "story") {
		// We need to insert a leading slash to story paths so that browsers treat the URls as links relative to our root domain. We also trim any extra trailing slashes.
		const baseUrl = `/${trim(url, "/")}`;

		// Story link anchors are handled as a separate field
		let anchorStr = "";
		if (link.anchor) {
			// We allow users to actually input the whole query parameter + anchor portion themselves, not just the anchor. They must do so by copying the entire part that should come after the URLs path, so it will contain either a hash or a question mark character.
			if (link.anchor.includes("#") || link.anchor.includes("?")) {
				anchorStr = link.anchor;
			}
			// This is the "default way" SB intends anchors to be used, support that too
			else {
				anchorStr = `#${link.anchor}`;
			}
		}

		return `${baseUrl}${anchorStr}`;
	}

	// These may be regular HTTP links, asset links or mailto links

	// Enforce links to external sites being absolute (with a protocol), otherwise they may be whatever the user inputted
	if (
		link.linktype === "url" &&
		!url.startsWith("https://") &&
		!url.startsWith("http://") &&
		!url.startsWith("/")
	) {
		return `https://${url}`;
	}

	// If the linktype is "email" we could prepend `mailto:` if the url doesn't start with that already. Currently we don't do that.
	// Asset links can be returned just as-is.
	return url;
}
